export var IconPrefix;
(function (IconPrefix) {
    IconPrefix["FontAwesome"] = "fa-";
})(IconPrefix || (IconPrefix = {}));
export var IconSet;
(function (IconSet) {
    IconSet["FALight"] = "fal";
    IconSet["FABrand"] = "fab";
})(IconSet || (IconSet = {}));
export var IconCssClass;
(function (IconCssClass) {
    IconCssClass["Base"] = "iress-icon";
    IconCssClass["Rotate180"] = "iress-icon--rotate-180";
    IconCssClass["Rotate270"] = "iress-icon--rotate-270";
    IconCssClass["Rotate90"] = "iress-icon--rotate-90";
    IconCssClass["FlipBoth"] = "iress-icon--flip-both";
    IconCssClass["FlipHorizontal"] = "iress-icon--flip-horizontal";
    IconCssClass["FlipVertical"] = "iress-icon--flip-vertical";
    IconCssClass["SpinHalf"] = "iress-icon--spin-half";
    IconCssClass["Spin1"] = "iress-icon--spin-1";
    IconCssClass["Spin2"] = "iress-icon--spin-2";
    IconCssClass["Spin3"] = "iress-icon--spin-3";
    IconCssClass["Icon"] = "iress-icon__icon";
    IconCssClass["SrOnly"] = "sr-only";
})(IconCssClass || (IconCssClass = {}));
export var IconFlip;
(function (IconFlip) {
    IconFlip["Both"] = "both";
    IconFlip["Horizontal"] = "horizontal";
    IconFlip["Vertical"] = "vertical";
})(IconFlip || (IconFlip = {}));
export var IconRotate;
(function (IconRotate) {
    IconRotate["Deg180"] = "180";
    IconRotate["Deg270"] = "270";
    IconRotate["Deg90"] = "90";
})(IconRotate || (IconRotate = {}));
export var IconSpin;
(function (IconSpin) {
    IconSpin[IconSpin["SpinHalf"] = 0.5] = "SpinHalf";
    IconSpin[IconSpin["Spin1"] = 1] = "Spin1";
    IconSpin[IconSpin["Spin2"] = 2] = "Spin2";
    IconSpin[IconSpin["Spin3"] = 3] = "Spin3";
})(IconSpin || (IconSpin = {}));
//# sourceMappingURL=icon.types.js.map